/**
 * CSV download for list exports (FR-COL-23). Semicolons and a UTF-8 byte order mark so that
 * Excel in French opens the file with accents and columns intact.
 */
export function toCsv(rows: string[][]): string {
  const cell = (v: string) => (/[;"\n\r]/.test(v) ? `"${v.replace(/"/g, '""')}"` : v);
  return rows.map((r) => r.map((v) => cell(v ?? '')).join(';')).join('\r\n');
}

export function downloadCsv(fileName: string, rows: string[][]): void {
  const blob = new Blob(['﻿', toCsv(rows)], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName.replace(/[\\/:*?"<>|]+/g, '-');
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
